import { useMutation } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';

import {
  DeployPayload,
  RuntimeDispatch,
  runDeployErrorEffects,
  runDeploySuccessEffects
} from './deployMutationEffects';

import api from '~/api/runtime';

type CreateDeployVariables = {
  payload: DeployPayload;
  useV2Api?: boolean;
};

export function useCreateDeploy() {
  const dispatch = useDispatch() as unknown as RuntimeDispatch;

  const mutation = useMutation({
    mutationFn: ({ payload, useV2Api = false }: CreateDeployVariables) =>
      useV2Api ? api.createV2(payload) : api.create(payload),
    onSuccess: (_data, { payload }) =>
      runDeploySuccessEffects(dispatch, payload),
    onError: error => runDeployErrorEffects(dispatch, error)
  });

  return {
    createDeploy: mutation.mutateAsync,
    creating: mutation.isPending
  };
}
